import { Box, Button, Card,Tabs,Tab } from '@mui/material'
import React,{useState} from 'react'
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout'
import { useNavigate } from 'react-router-dom'
import useResponsive from '../../../hooks/useResponsive'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { ArrowBack, Edit } from '@mui/icons-material';
import AllBanners from './AllBanners'
import CustomerBanners from './customerApp/CustomerBanners'
import ExpertBanners from './expertApp/ExpertBanners'

const BannerList = () => {
  const {isSm} = useResponsive();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState('0');
  const handleChange = (event, newValue) => {
      setTabValue(newValue);
  }
  return (
    <Box>
      <PageHeaderLayout headerTitle={'Manage Banners'}>
          <Button size='small' variant='contained' onClick={()=>navigate('/marketing/banner/0')} sx={{ textTransform:'capitalize' }} startIcon={isSm ? '':<AddCircleIcon />}>
            Add New
          </Button>
          <Button size='small' variant='contained' onClick={()=>navigate(-1)} sx={{ textTransform:'capitalize' ,display:{xs:'none',sm:'flex'}}} startIcon={<ArrowBack />}>
            Back
          </Button>
        </PageHeaderLayout>
        <Box sx={{width:"100%"}}>
          <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
              <Box sx={{ width: '100%' }}>
                  <Tabs
                      value={tabValue}
                      onChange={handleChange}
                      textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary tabs example"
                      sx={{ p: 0, minHeight: '40px' }}
                      variant="scrollable"
                      scrollButtons="auto"
                  >
                    <Tab value="0" label="Customer App Slider" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    <Tab value="1" label="Expert App Slider" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    <Tab value="2" label="All Banners" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                  </Tabs>
              </Box>
          </Card>
          {tabValue === '2' && <AllBanners />}
          {tabValue === '0' && <CustomerBanners />}
          {tabValue === '1' && <ExpertBanners/>}
      </Box>
    </Box>
  )
}

export default BannerList
